import {InfoTooltip} from '@sollapay/ui/components';
import {Controller} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {PepYesNoField} from './PepYesNoField';

import type {PepPartyFormValues} from './pep-form.utils';
import type {Control, FieldValues} from 'react-hook-form';

export interface PepToggleFieldProps<T extends FieldValues> {
  control: Control<T>;
  isCorporate: boolean;
  pepPath?: string;
  toggleQuestionKey?: string;
  /** Clears all parties on toggle-off. `usePepParties` owns re-creating the individual-mode default party on toggle-on (see its docstring). */
  replace: (value: PepPartyFormValues[]) => void;
}

export function PepToggleField<T extends FieldValues>({
  control,
  isCorporate,
  pepPath = 'pep',
  toggleQuestionKey,
  replace
}: PepToggleFieldProps<T>) {
  const {t} = useTranslation('trustAccounts');
  const p = `activation.packages.trustDetails.form.fields.pep` as const;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const c = control as unknown as Control<any>;

  const resolvedToggleQuestionKey =
    toggleQuestionKey ?? (isCorporate ? 'toggleQuestion' : 'toggleQuestionIndividual');

  const tooltipText = t(`${p}.${resolvedToggleQuestionKey}Tooltip`, {defaultValue: ''});

  const handleToggle = (next: boolean) => {
    if (!next) {
      replace([]);
    }
  };

  return (
    <Controller
      name={`${pepPath}.isPep` as never}
      control={c}
      render={({field}) => (
        <PepYesNoField
          label={t(`${p}.${resolvedToggleQuestionKey}`)}
          tooltip={tooltipText && <InfoTooltip content={tooltipText} />}
          value={!!field.value}
          onChange={next => {
            field.onChange(next);
            handleToggle(next);
          }}
        />
      )}
    />
  );
}
